<template>
  <div class="page-cover">
    <div class="header-wrap" ref="headerWrap">

      <div class="ctrl-panel van-clearfix">
        <div class="date-picker-block" style="width: 50%;" @click="openCalendar">
          <span>日期：{{ date }}</span>
          <van-icon name="arrow-down"/>
        </div>
        <div class="date-picker-block" style="width: 50%;" @click="showScenicTypeSelect = true">
          <span>项目：{{ scenicTypeList[scenicTypeSelectIndex] }}</span>
          <van-icon name="arrow-down"/>
        </div>
      </div>

    </div>
    <el-table
        :data="list"
        :highlight-current-row="false"
        :row-class-name="tableRowClassName"
        border
        class="table noneHoveTable"
        :height="tableHeight"
        ref="myTable"
    >

      <el-table-column
          align="center"
          label="城市"
          min-width="60"
      >
        <template slot-scope="{row}">
          <span>{{ row.cityName }}</span>
        </template>
      </el-table-column>

      <el-table-column
          align="right"
          label="团队人次"
          min-width="60"
      >
        <template slot-scope="{row}">
          <span v-if="row.personCount">{{ row.personCount }}</span>
          <span v-else>-</span>
        </template>
      </el-table-column>

      <el-table-column
          label="团队营收"
          align="right"
          min-width="60"
      >
        <template slot-scope="{row}">
          <span v-if="row.revenue">{{ row.revenue }}</span>
          <span v-else>-</span>
        </template>
      </el-table-column>

    </el-table>
    <div style="height:0.2rem;"></div>
    <!--日历选择-->
    <van-calendar v-model="showCalendar"
                  :default-date="calendarDate"
                  :min-date="new Date(2021, 0, 1)"
                  @confirm="onCalendarConfirm"
    />
    <!--类型选择-->
    <van-popup v-model="showScenicTypeSelect" position="bottom" :style="{ height: '40%' }">
      <van-picker
          title="选择项目"
          show-toolbar
          :columns="scenicTypeList"
          :default-index="scenicTypeSelectIndex"
          @confirm="onConfirmScenicType"
          @cancel="showScenicTypeSelect = false"
      />
    </van-popup>


  </div>
</template>

<script>
import {
  getScenicOfflineRevenues
} from '@/api/global'
import { removeAccessToken, removeAccessTokenExpiredTime } from '../utils/auth'
// import { getCode } from '../utils/utils'
import '@vant/touch-emulator'

export default {
  name: 'index.vue',
  data: () => {
    return {
      list: [], // 表格数据

      calendarDate: undefined, // 日历保存的数据

      date: '', // 日历保存的数据 的 字符串

      tableHeight: 700, // 表格高度, 初始化700, 启动后会重新设置

      showCalendar: false, // 显示日历的开关

      userId: 0, // 用户内网ID

      randomNumber: 0, // 一个随机数

      loading: true,

      showScenicTypeSelect: false, // 控制景区选择的显示

      scenicTypeList: ['云上草原门票', '茅山森林门票', '熊猫探险部落门票'], // 景区类型选择

      scenicTypeSelectIndex: 0 // 选中的景区
    }
  },
  created () {
    // 清空上次的token
    removeAccessTokenExpiredTime()
    removeAccessToken()

    // 初始化单选日期的值, 判断URL有没有带日期进来, 没有的话就取昨天日期
    const dateQuery = (this.$route.query.date === 'undefined' || !this.$route.query.date) ? '' : this.$route.query.date
    if (dateQuery) {
      this.date = dateQuery
      this.calendarDate = new Date(dateQuery)
    } else {
      // 获取上个月
      this.date = this.formatDate(new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate() - 1))
      this.calendarDate = new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate() - 1)
    }

    // 保存范围日期值 dateRange
    // this.rangeDate[0] = this.formatDate(new Date(new Date().setDate(new Date().getDate() - 7)))
    // this.rangeDate[1] = this.formatDate(new Date(new Date().setDate(new Date().getDate() - 1)))

    // 一个随机数 有用的地方就拿来用
    this.randomNumber = Math.floor(Math.random() * 1000)
    console.log('生成一个随机数', this.randomNumber)

    // data.chooseCompareYears: [], // 用于对比时选择年份的数组
    // const currentYear = new Date().getFullYear()
    // const years = []
    // for (let i = currentYear - 1; i >= 2021; i--) {
    //   years.push({ name: i })
    // }
    // this.chooseCompareYears = years

    // const userId1000122 = Cookies.get('userId1000122') ? Cookies.get('userId1000122') : ''
    // if (userId1000122 === 'undefined' || !userId1000122) {
    //   this.$router.push('/login')
    //   return
    // }

    this.getData()
  },
  mounted () {
    window.addEventListener('resize', this.handleWindowResize)
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.handleWindowResize)
  },
  methods: {
    // 打开日历
    openCalendar () {
      this.showCalendar = true
    },
    // 窗口大小改变, 重新渲染表格
    handleWindowResize () {
      try {
        console.log('窗口大小改变')
        this.$refs.myTable.doLayout()
        this.calculateTableHeight()
      } catch (e) {
        console.log('窗口大小改变catch', e)
      }
    },
    // 计算表格渲染高度
    calculateTableHeight () {
      const headerWrapHeight = this.$refs.headerWrap.offsetHeight
      const windowHeight = window.innerHeight
      console.log(`头部高度${headerWrapHeight}px, 屏幕高度${windowHeight}px.`)
      if (headerWrapHeight > 0 && windowHeight > 0) {
        this.tableHeight = windowHeight - headerWrapHeight - 30
      }
    },
    // 获取数据
    getData () {
      // 请求数据
      this.list = []
      // 加载动画开始
      this.$toast.loading({
        message: '加载中...',
        forbidClick: true,
        duration: 0
      })
      // const start = this.formatDate(this.calendarDate)
      // const end = this.formatDate(this.calendarDate)
      getScenicOfflineRevenues((this.scenicTypeSelectIndex * 1 + 1) * 10, this.date).then((data) => {
        console.log('getScenicOfflineRevenues', data)
        this.$toast.clear()
        if (data && data.length) {

          // 将最后一个数据挪到第一个
          if (data.length > 2) {
            const lastObj = data.pop()
            data.unshift(lastObj)
          }

          this.list = data
        }

        // 修复错位问题
        this.$nextTick(() => {
          try {
            this.$refs.myTable.doLayout()
          } catch (e) {
            console.log(e)
          }
        })
        // 计算高度
        this.calculateTableHeight()
      }).catch((err) => {
        // 网络错误
        console.log(err)
        this.$toast.clear()
        this.$toast('网络异常 请稍后再试')
      })
    },
    // 确认选择景区项目
    onConfirmScenicType (str, idx) {
      console.log('onConfirmScenicType 已选择: ', str)
      this.scenicTypeSelectIndex = idx
      this.showScenicTypeSelect = false
      this.getData()
    },

    onCalendarConfirm (date) {
      this.dateChooseType = 'single'
      this.calendarDate = date
      this.showCalendar = false
      this.date = this.formatDate(date)
      this.getData()
    },
    formatDate (date) {
      return `${date.getFullYear()}-${this.repairZero(date.getMonth() + 1)}-${this.repairZero(date.getDate())}`
    },
    repairZero (num) {
      return num < 10 ? '0' + num : num
    },
    dateFilter (time) {
      const date = new Date(time)
      return date.getFullYear() + '-' + this.repairZero(date.getMonth() + 1) + '-' + this.repairZero(date.getDate())
    },
    thousandsFilter (number) {
      let arr = String(number).split('.')
      let num = arr[0]
      let len = Math.ceil(num.length / 3) * 3
      let result = num.padStart(len, '0').match(/\d{3}/g).join(',').replace(/^0+/, '')
      return arr[1] ? result + '.' + arr[1] : result
    },

    tableRowClassName ({ row }) {
      // 返回数据isTotal为true是合计行
      if (row.rowType === 1) {
        return 'table-total-row'
      }
      if (row.rowType === 2) {
        return 'table-total-row-all'
      }

    }
  },
  filters: {
    roundFilter (number) {
      // console.log(number)
      return Math.trunc(number + 0)
    },
    thousandsFilter (number) {
      if (isNaN(number)) {
        return '-'
      }
      if (number) {

        let arr = String(number).split('.')
        let num = arr[0]
        let miner = false
        if (num.startsWith('-')) {
          num = num.substring(1)
          miner = true
        }

        let len = Math.ceil(num.length / 3) * 3
        let result = num.padStart(len, '0').match(/\d{3}/g).join(',').replace(/^0+/, '')
        let returnStr = arr[1] ? result + '.' + arr[1] : result
        if (miner) {
          returnStr = '-' + returnStr
        }
        return returnStr
      } else {
        return ''
      }
    },
    keepTwoDecimalFilter (number) {
      if (number) {
        const reg = /^(.*\..{2}).*$/
        return Number(String(number).replace(reg, '$1'))
      } else {
        return ''
      }
    }
  }
}
</script>

<style lang="less" scoped>

.page-cover {
  width: 7.5rem;
  margin: 0 auto;

  /deep/ .van-calendar__selected-day {
    background-color: #0e43a4 !important;
  }

  /deep/ .van-calendar__day--start {
    background-color: #0e43a4 !important;
  }

  /deep/ .van-calendar__day--end {
    background-color: #0e43a4 !important;
  }

  /deep/ .van-calendar__day--middle {
    background-color: #aad8ff !important;
    color: #666;
  }

  /deep/ .van-button--danger {
    color: #fff;
    background-color: #0e43a4;
    border: 1px solid #0e43a4;
  }

  /deep/ .van-button--primary {
    background-color: #1948b3;
    border: 1px solid #1948b3;
  }
}

.header-wrap {
  width: 7.5rem;
  margin: 0 auto;
  //height: 5rem;
  background-image: linear-gradient(to right, #264ec4, #0e43a4);
  position: relative;


  .show-old-btn {
    color: #fff;
    font-size: .2rem;
    line-height: .56rem;
    text-align: right;
    padding-right: .25rem;

    .field {
      float: right;
    }

    .switch-con {
      float: right;
      margin-top: .1rem;
      margin-left: .1rem;
    }
  }

  .date-picker-block {
    padding-top: .2rem;
    //padding-bottom: .2rem;
    width: 50%;
    box-sizing: border-box;
    float: left;

    &:first-child {
      //padding-top: .4rem;
    }

    color: #fff;
    font-size: .28rem;
    line-height: .36rem;
    margin-bottom: .18rem;
    text-align: left;
    //padding-top: .4rem;
    padding-left: .2rem;
    cursor: pointer;

    span {
      padding-right: .1rem;
      float: left;
    }

    ul {
      float: left;

      li {
        &.active {
          opacity: 1;
          text-decoration: underline;
          //font-size: .3rem;
          //font-weight: bold;
        }

        float: left;
        margin-right: .18rem;
        opacity: .5;
      }
    }
  }

  .total-data-show {
    display: flex;
    justify-content: center;
    flex-wrap: wrap;
    margin-top: .3rem;

    .item {
      width: 50%;
      text-align: center;
      color: #fff;
      margin-bottom: .25rem;

      .value {
        font-size: .36rem;
        line-height: .6rem;
      }

      .sub-value {
        font-size: .24rem;
        line-height: .24rem;
      }

      .fields {
        font-size: .26rem;
        line-height: .48rem;
        color: #a4b6e2;
      }
    }
  }

  .slide-show {
    text-align: center;
    color: #fff;
    font-size: .3rem;
    line-height: .5rem;
    cursor: pointer;
    background-color: #0e43a4;
  }
}

.link-value {
  text-decoration: underline;
  color: #4f86ed;
}

.bottom-btn-group {
  margin-top: .2rem;
  margin-bottom: .1rem;
  display: flex;
  justify-content: center;

  .bottom-btn {
    margin-left: .1rem;
    //width: 3.39rem;
    width: 100%;
    margin-right: .1rem;
  }
}

.fast-month-inner {
  color: #fff;
  position: absolute;
  right: 0.25rem;
  top: 0.28rem;
  cursor: pointer;
  line-height: .24rem;
  font-size: .18rem;
  background-image: url("~@/assets/fast-month.png");
  background-repeat: no-repeat;
  padding-left: .45rem;
  background-position: left center;
  background-size: .4rem .4rem;
}

.fast-month-choose {
  width: 7.2rem;
  height: 3.8rem;
  border-radius: .24rem;

  .fmc-title {
    font-size: .34rem;
    line-height: .88rem;
    text-align: center;
    padding-top: .2rem;
  }

  .fmc-list {
    padding-left: .12rem;

    .fmc-item {
      float: left;
      width: 1.07rem;
      margin-right: .1rem;
      text-align: center;
      line-height: .8rem;
      margin-bottom: .12rem;
      color: #666;
      //font-weight: bold;
      height: 0.8rem;
      font-size: .4rem;
      cursor: pointer;
      //background-color: #aad8ff;
      border-radius: .13rem;
      box-sizing: border-box;
      border: 1px solid #999;

      &.active {
        background-color: #0e43a4;
        border: 1px solid #0e43a4;
        color: #fff;
      }
    }
  }

  .fmc-info {
    font-size: .28rem;
    line-height: .48rem;
    color: #3d43e4;
    text-align: center;
  }
}

/* 弹出层白色区域的圆角 */
/deep/ .fast-month-popup-cover .van-popup {
  border-radius: .2rem !important;
}

.el-table tbody tr {
  pointer-events: none;
}




</style>

